/**
 * Search component is used to enter queries and see query results
 * in list form of SearchItem components. Once a search element
 * is selected by clicking, detailed view is shown
 * via SearchDetail component.
 */
<template>
<div>
    <div class="control has-icons-right">
        <div class="field">
            <input class="input-default" type="text" v-model="selectedQuery"
                @input="debouncedSetQuery($event.target.value)"
                :placeholder="$t('message.searchPlaceholder')" />
            <span class="icon is-right" @click="clearQuery"
                v-if="selectedQuery">
                <img
                    src="../assets/icon-x.svg"
                    height="12px" width="12px" />
            </span>
        </div>
    </div>
    <div
        class="search-items is-clipped"
        v-if="noResults">
        <div class="item-result is-max-fullwidth">
            <img
                class="is-constant-size"
                src="../assets/error-symbol.svg"
                alt="" height="16px" width="16px">
            <p class="is-clipped is-ellipsed">
                {{ $t('message.couldNotFind') }} "{{ this.query }}"
            </p>
        </div>
        <div class="item-detail">
            <p>{{ $t('message.checkSpelling') }}</p>
        </div>
    </div>
    <div
        class="search-items"
        v-else>
        <SearchItem
            v-for="result in results"
            @click="select(result.item)"
            :title="result.title" :detailAddress="result.detailAddress"
            :key="result.id" />
    </div>
</div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';

import debounce from 'debounce';

import SearchItem from './SearchItem.vue';

export default {
    data() {
        return {
            selectedQuery: '',
        };
    },

    computed: {
        ...mapState('search', ['query']),
        ...mapGetters('search', ['results', 'noResults']),
    },

    components: {
        SearchItem,
    },

    methods: {
        ...mapActions('search', ['setQuery', 'clearQuery', 'select']),
    },

    created() {
        this.selectedQuery = this.query;

        /**
         * To prevent sending requests to TomTom API after each user
         * keypress, debounce with period of 1 s is set.
         */
        this.debouncedSetQuery = debounce(this.setQuery, 1000);
    },

    watch: {
        query() {
            this.selectedQuery = this.query;
        },
    },
};
</script>
